import React, { useEffect, useState } from 'react';
import Popup from './Popup';
import { getItem } from 'utils/local-storage';
import useSaveLead from 'hooks/useSaveLead';
import { ACCESS_TOKEN, USER_PROFILE } from 'utils/storage-keys';
import axios from 'axios';
import env from 'utils/env';
import { Button, message } from 'antd';
import { useGetUserProfileApi } from 'pages/dashboard/user/useUserApi';

type Props = {
  membership: string;
  siteCode: string;
  money: number;
  setShowPopup: (state: boolean) => void;
};

const isPhoneValid = (number: string) => {
  return /(((\+|)84)|0)(3|5|7|8|9)+([0-9]{8})\b/.test(number);
};

const UpgradePopup: React.FC<Props> = ({
  membership,
  money,
  siteCode,
  setShowPopup
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [phoneValid, setPhoneValid] = useState(true);
  const [phone, setPhone] = useState('');
  const config = env();
  const token = getItem(ACCESS_TOKEN);
  const userId = JSON.parse(getItem(USER_PROFILE) || "{}")?.user_id || '';
  const { profileObject } = useGetUserProfileApi();
  const { saveLead } = useSaveLead();

  useEffect(() => {
    if (!token || !profileObject) return;
    if (!profileObject?.data?.username) {
      message.error('Vui lòng cập nhập họ và tên hợp lệ!');
      return setShowPopup(false);
    }
    if (!isPhoneValid(profileObject?.data?.phone)) {
      return setPhoneValid(false);
    }

    saveLead(profileObject, membership, {}, {
      site_code: siteCode,
      unused_money: money,
      session_token: token,
      is_upgrade: true,
      user_id: userId
    });
  }, [membership, money, profileObject, siteCode, token, saveLead, userId, setShowPopup]);

  const handleSubmitPhone = async () => {
    if (!token) return;
    if (!isPhoneValid(phone))
      return message.error('Số điện thoại không hợp lệ!');
    setIsLoading(true);
    try {
      await axios.patch(
        `${config.baseApiUrl}/user/api/v1/account`,
        {
          phone
        },
        {
          headers: {
            'X-Session-Token': token
          }
        }
      );

      const newProfile = {
        ...profileObject,
        data: { ...profileObject?.data, phone }
      }
      saveLead(newProfile, membership, {}, {
        site_code: siteCode,
        unused_money: money,
        session_token: token,
        is_upgrade: true,
        user_id: userId,
      });
    } catch (error) {
      message.error('Hệ thống đang bận vui lòng thử lại sau!');
      setIsLoading(false);
    }
  };

  return (
    <Popup>
      {phoneValid ? (
        <h2>Yêu cầu của bạn đang được xử lí… </h2>
      ) : (
        <div className="form-phone">
          <h3>
            Vui lòng thêm số điện thoại và thông tin cá nhân của bạn để chúng
            tôi có thể hỗ trợ dễ dàng hơn
          </h3>
          <div className="form-input">
            <label htmlFor="phone">Số điện thoại</label>
            <input
              type="phone"
              name="phone"
              id="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          <Button className="btn-primary" onClick={handleSubmitPhone} loading={isLoading}>
            Đăng ký ngay
          </Button>
          <button className="btn-white" onClick={() => setShowPopup(false)}>
            Hủy đăng ký
          </button>
        </div>
      )}
    </Popup>
  );
};

export default UpgradePopup;
